import React, {useState, useEffect, useCallback} from "react";
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import { apiClient } from "../../components/api/ApiClient";

function AddProductModal({onAdd, onUpdate, onClose, activeAlgo, requiredFields, product, mode, userConfigure}) {
    const [inputErrors, setInputErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [userProfProducts, setUserProfProducts] = useState([]);
    const [showUserProfProducts, setShowUserProfProducts] = useState(false);
    const measurementOption = [
        {value: '1611', label: 'لنگه'},
        {value: '1612', label: 'عدل'},
        {value: '1613', label: 'جعبه'},
        {value: '1618', label: 'توپ'},
        {value: '1619', label: 'ست'},
        {value: '1620', label: 'دست'},
        {value: '1624', label: 'کارتن'},
        {value: '1627', label: 'عدد'},
        {value: '1628', label: 'بسته'},
        {value: '1629', label: 'پاکت'},
        {value: '1631', label: 'دستگاه'},
        {value: '1640', label: 'تخته'},
        {value: '1641', label: 'رول'},
        {value: '1642', label: 'طاقه'},
        {value: '1643', label: 'جفت'},
        {value: '1645', label: 'متر مربع'},
        {value: '1649', label: 'پالت'},
        {value: '1661', label: 'دوجین'},
        {value: '1668', label: 'حلقه(رینگ)'},
        {value: '1673', label: 'قراص'},
        {value: '1694', label: 'قراصه'},
        {value: '1637', label: 'لیتر'},
        {value: '1650', label: 'ساشه'},
        {value: '1683', label: 'کپسول'},
        {value: '1656', label: 'ندیل'},
        {value: '1630', label: 'حلقه(رول)'},
        {value: '163', label: 'قالب'},
        {value: '1660', label: 'شانه'},
        {value: '1647', label: 'متر مكعب'},
        {value: '1689', label: 'ثوب'},
        {value: '1690', label: 'نیم دوجین'},
        {value: '1635', label: 'قرقره'},
        {value: '164', label: 'کیلوگرم'},
        {value: '1638', label: 'بطری'},
        {value: '161', label: 'برگ'},
        {value: '1625', label: 'سطل'},
        {value: '1654', label: 'ورق'},
        {value: '1646', label: 'شاخه'},
        {value: '1644', label: 'قوطي'},
        {value: '1617', label: 'جلد'},
        {value: '162', label: 'تیوب'},
        {value: '165', label: 'متر'},
        {value: '1610', label: 'کالف'},
        {value: '1615', label: 'کیسه'},
        {value: '1680', label: 'طغرا'},
        {value: '1639', label: 'بشكه'},
        {value: '1614', label: 'گالن'},
        {value: '1687', label: 'فاقد بسته بندی'},
        {value: '1693', label: 'کارتن(master case)'},
        {value: '166', label: 'صفحه'},
        {value: '1666', label: 'مخزن'},
        {value: '1626', label: 'تانكر'},
        {value: '1648', label: 'دبه'},
        {value: '1684', label: 'سبد'},
        {value: '169', label: 'تن'},
        {value: '1651', label: 'بانكه'},
        {value: '1633', label: 'سیلندر'},
        {value: '1679', label: 'فوت مربع'},
        {value: '168', label: 'حلب'},
        {value: '1665', label: 'شیت'},
        {value: '1659', label: 'چلیك'},
        {value: '1636', label: 'جام'},
        {value: '1622', label: 'گرم'},
        {value: '1616', label: 'نخ'},
        {value: '1652', label: 'شعله'},
        {value: '1678', label: 'قیراط'},
        {value: '16100', label: 'میلي لیتر'},
        {value: '16101', label: 'میلي متر'},
        {value: '16102', label: 'میلي گرم'},
        {value: '16103', label: 'ساعت'},
        {value: '16104', label: 'روز'},
        {value: '16105', label: 'تن کیلومتر'},
        {value: '1669', label: 'کیلووات ساعت'},
        {value: '1676', label: 'نفر'},
        {value: '16110', label: 'ثانیه'},
        {value: '16111', label: 'دقیقه'},
        {value: '16112', label: 'ماه'},
        {value: '16113', label: 'سال'},
        {value: '16114', label: 'قطعه'},
        {value: '16115', label: 'سانتي متر'},
        {value: '16116', label: 'سانتي متر مربع'},
        {value: '1632', label: 'فروند'},
        {value: '1653', label: 'واحد'},
        {value: '16108', label: 'لیوان'},
        {value: '16117', label: 'نوبت'},
        {value: '16118', label: 'مگا وات ساعت'},
        {value: '16119', label: 'گیگا بایت بر ثانیه'},
        {value: '1681', label: 'ویال'},
        {value: '1667', label: 'حلقه(دیسك)'},
        {value: '16120', label: 'نسخه(جلد)'},
        {value: '16121', label: 'نفر- ساعت'},
        {value: '16122', label: 'کیلومتر'},
        {value: '16125', label: 'آمپر'},
        {value: '16126', label: 'میلي آمپر'},
        {value: '16127', label: 'مثقال'},
        {value: '16128', label: 'سیر'},
        {value: '16129', label: 'دفعه(time)'},
        {value: '16130', label: ' مگا یونیت'},
        {value: '16131', label: 'کادر'},
        {value: '16132', label: 'پرس'},
        {value: '16133', label: 'بلوک'},
    ]
    // const currencyOption = []
    const [currencyOption, setCurrencyOption] = useState([])

    const [productId, setProductId] = useState('');
    const [name, setName] = useState('');
    const [measurement, setMeasurement] = useState('');
    const [count, setCount] = useState(null);
    const [amount, setAmount] = useState('');
    const [weight, setWeight] = useState(null);
    const [currency, setCurrency] = useState('IRR');
    const [unitPrice, setUnitPrice] = useState('');
    const [currencyAmount, setCurrencyAmount] = useState(null);
    const [currencyPrice, setCurrencyPrice] = useState(null);
    const [rialValue, setRialValue] = useState(null);
    const [currencyValue, setCurrencyValue] = useState(null);
    const [priceBeforeSale, setPriceBeforeSale] = useState('');
    const [salePrice, setSalePrice] = useState('');
    const [priceAfterSale, setPriceAfterSale] = useState('');
    const [taxPercent, setTaxPercent] = useState('');
    const [taxPrice, setTaxPrice] = useState('');
    const [otherTaxS, setOtherTaxS] = useState('');
    const [otherTaxR, setOtherTaxR] = useState('');
    const [otherTaxP, setOtherTaxP] = useState(0);
    const [otherLegalS, setOtherLegalS] = useState('');
    const [otherLegalR, setOtherLegalR] = useState('');
    const [otherLegalP, setOtherLegalP] = useState(0);
    const [constructionFee, setConstructionFee] = useState(null);
    const [sellerProfit, setSellerProfit] = useState(null);
    const [commission, setCommission] = useState(null);
    const [sumCSC, setSumCSC] = useState('');
    const [constructionFeeNum, setConstructionFeeNum] = useState('');
    const [cashContribution, setCashContribution] = useState(null);
    const [vpp, setVpp] = useState(null);
    const [showVppSuggestions, setShowVppSuggestions] = useState(false);
    const [vppSuggestions, setVppSuggestions] = useState([]);

    const handleSelectVppSuggestion = (value) => {
        setVpp(value);
        setShowVppSuggestions(false);
    };
    const [totalPrice, setTotalPrice] = useState('');
    const [diffRialCurrency, setDiffRialCurrency] = useState(null);
    const [carat, setCarat] = useState(null);
    const [taxSource, setTaxSource] = useState(null);
    useEffect(() => {
        getCurrencies()
        if (product) {
            setProductId(product.product.productId || "");
            setName(product.product.name || "");
            setMeasurement(product.product.measurement || "");
            setCount(product.product.count ?? null);
            setAmount(product.product.amount ?? "");
            setWeight(product.product.weight ?? null);
            setCurrency(product.product.currency ?? "");
            setUnitPrice(product.product.unitPrice ?? "");
            setCurrencyAmount(product.product.currencyAmount ?? null);
            setCurrencyPrice(product.product.currencyPrice ?? null);
            setRialValue(product.product.rialValue ?? null);
            setCurrencyValue(product.product.currencyValue ?? null);
            setPriceBeforeSale(product.product.priceBeforeSale ?? "");
            setSalePrice(product.product.salePrice ?? "");
            setPriceAfterSale(product.product.priceAfterSale ?? "");
            setTaxPercent(product.product.taxPercent ?? "");
            setTaxPrice(product.product.taxPrice ?? "");
            setOtherTaxS(product.product.otherTaxS ?? "");
            setOtherTaxR(product.product.otherTaxR ?? "");
            setOtherTaxP(product.product.otherTaxP ?? "");
            setOtherLegalS(product.product.otherLegalS ?? "");
            setOtherLegalR(product.product.otherLegalR ?? "");
            setOtherLegalP(product.product.otherLegalP ?? "");
            setConstructionFee(product.product.constructionFee ?? null);
            setSellerProfit(product.product.sellerProfit ?? null);
            setCommission(product.product.commission ?? null);
            setConstructionFeeNum(product.product.constructionFeeNum ?? "");
            setTotalPrice(product.product.totalPrice ?? "");
            setCashContribution(product.product.cashContribution ?? null);
            setVpp(product.product.vpp ?? null);
            setDiffRialCurrency(product.product.diffRialCurrency ?? null);
            setCarat(product.product.carat ?? null);
            setTaxSource(product.product.taxSource ?? null);
        } else {
        }
    }, [product]);

    const getCurrencies = async () => {
        try {
            const response = await apiClient('/account/api/currencies/');
            if (Array.isArray(response) && response.length > 0) {
                const currenciesData = response.map(i => ({
                    value: i.symbol,
                    label: `${i.fa_name} ( ${i.country_fa_name} )`,
                }))
                setCurrencyOption(currenciesData)
                if (product?.product?.currency) {

                    const selectedCurrency = currenciesData.find(
                        c => Number(c.value) === Number(product.product.currency)
                    );
                    console.log(selectedCurrency)
                    if (selectedCurrency) {
                        setCurrency(selectedCurrency.value);
                    }
                } else {
                    setCurrency('IRR');
                }
            }
        } catch (e) {
            console.log(e)
        }
    }
    // const isRequired = (fieldName) => {
    //     return requiredFields?.includes(fieldName);
    // };
    const isRequired = useCallback(
        (fieldName) => {
            return userConfigure?.[fieldName]?.required ?? false;
        },
        [userConfigure]
    );
    const isShow = useCallback(
        fieldName => userConfigure?.[fieldName]?.active ?? true,
        [userConfigure]
    );
    const handleSelectUserProfProducts = (item) => {
        console.log(item)
        setProductId(item.identity)
        setName(item.name)
        setTaxPercent(item.taxPercent)
    }
    const handleFieldChange = useCallback(({
                                               setter,
                                               fieldName,
                                               onlyPositive = false,
                                               maxDigits = null,
                                               maxDecimals = null,
                                               type = 'number'
                                           }) => (e) => {
        let newValue = e.target.value;
        const total = parseFloat(totalPrice) || 0;

        if (fieldName === 'salePrice') {
            const salePrice = parseFloat(newValue) || 0;
            if (salePrice > priceBeforeSale) {
                newValue = priceBeforeSale;
            }
        }
        if (fieldName === 'cashContribution') {
            const cashContribution = parseFloat(newValue) || 0;
            if (cashContribution > total) {
                newValue = total;
            }
        }
        if (type === 'number' && !/^\d*\.?\d*$/.test(newValue)) {
            return;
        }
        if (newValue === "") {
            setter("");
            return;
        }
        if (onlyPositive && Number(newValue) < 0) {
            return;
        }
        const [intPart, decimalPart] = String(newValue).split(".");
        if (maxDigits && intPart.length > maxDigits) {
            return;
        }
        if (maxDecimals && decimalPart?.length > maxDecimals) {
            return;
        }
        setter(String(newValue));
        setInputErrors((prevErrors) => {
            if (prevErrors[fieldName]) {
                return {...prevErrors, [fieldName]: ""};
            }
            return prevErrors;
        });
    }, [totalPrice]);
    const handleChangeSelect = (selectedOption, fieldName) => {
        if (fieldName === "measurement") {
            setMeasurement(selectedOption.value);
            setInputErrors((prevErrors) => {
                if (prevErrors["measurement"]) {
                    return {...prevErrors, measurement: ""};
                }
                return prevErrors;
            });
        } else if (fieldName === "currency") {
            setCurrency(selectedOption.value);
            setInputErrors((prevErrors) => {
                if (prevErrors["currency"]) {
                    return {...prevErrors, currency: ""};
                }
                return prevErrors;
            });
        }
    };
    const validateFields = () => {
        const formValues = {
            productId,
            name,
            measurement,
            count,
            amount,
            weight,
            currency,
            unitPrice,
            currencyAmount,
            currencyPrice,
            rialValue,
            currencyValue,
            priceBeforeSale,
            salePrice,
            priceAfterSale,
            taxPercent,
            taxPrice,
            otherTaxS,
            otherTaxR,
            otherTaxP,
            otherLegalS,
            otherLegalR,
            otherLegalP,
            constructionFee,
            sellerProfit,
            commission,
            sumCSC,
            constructionFeeNum,
            cashContribution,
            vpp,
            totalPrice,
            diffRialCurrency,
            carat,
            taxSource,
        };

        const errors = {};
        const isEmpty = (val) => {
            return (
                val === undefined ||
                val === null ||
                (typeof val === "string" && val.trim() === "")
            );
        };
        Object.entries(userConfigure || {}).forEach(([field, config]) => {
            if (config.required && field in formValues && isEmpty(formValues[field])) {
                console.log(field)
                errors[field] = "این فیلد الزامی است";
            }
        });
        // requiredFields?.forEach(field => {
        //     if (field in formValues && isEmpty(formValues[field])) {
        //         console.log(field);
        //         errors[field] = "این فیلد الزامی است";
        //     }
        // });
        setInputErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handleSubmit = () => {
        if (!validateFields()) {
            return;
        }

        const newProduct = {
            productId,
            name,
            measurement,
            count,
            amount,
            weight,
            currency,
            unitPrice,
            currencyAmount,
            currencyPrice,
            rialValue,
            currencyValue,
            priceBeforeSale,
            salePrice,
            priceAfterSale,
            taxPercent,
            taxPrice,
            otherTaxS,
            otherTaxR,
            otherTaxP,
            otherLegalS,
            otherLegalR,
            otherLegalP,
            constructionFee,
            sellerProfit,
            commission,
            sumCSC,
            constructionFeeNum,
            cashContribution,
            vpp,
            totalPrice,
            diffRialCurrency,
            carat,
            taxSource,
        };

        if (product) {
            onUpdate({...newProduct, index: product.index});
        } else {
            onAdd(newProduct);
        }
        onClose();
        // setProductId('');
    };
    const handleSubmitAndAdd = () => {
        if (!validateFields()) {
            return;
        }

        const newProduct = {
            productId,
            name,
            measurement,
            count,
            amount,
            weight,
            currency,
            unitPrice,
            currencyAmount,
            currencyPrice,
            rialValue,
            currencyValue,
            priceBeforeSale,
            salePrice,
            priceAfterSale,
            taxPercent,
            taxPrice,
            otherTaxS,
            otherTaxR,
            otherTaxP,
            otherLegalS,
            otherLegalR,
            otherLegalP,
            constructionFee,
            sellerProfit,
            commission,
            sumCSC,
            constructionFeeNum,
            cashContribution,
            vpp,
            totalPrice,
            diffRialCurrency,
            carat,
            taxSource,
        };

        if (product) {
            onUpdate({...newProduct, index: product.index});
        } else {
            onAdd(newProduct);
        }
        setProductId(null);
        setName(null);
        setMeasurement(null);
        setCount(null);
        setAmount(null);
        setWeight(null);
        setCurrency(null);
        setUnitPrice(null);
        setCurrencyAmount(null);
        setCurrencyPrice(null);
        setRialValue(null);
        setCurrencyValue(null);
        setPriceBeforeSale(null);
        setSalePrice(null);
        setPriceAfterSale(null);
        setTaxPercent("");
        setTaxPrice("");
        setOtherTaxS("");
        setOtherTaxR("");
        setOtherTaxP("");
        setOtherLegalS("");
        setOtherLegalR("");
        setOtherLegalP("");
        setConstructionFee(null);
        setSellerProfit(null);
        setCommission(null);
        setConstructionFeeNum("");
        setTotalPrice("");
        setCashContribution(null);
        setVpp(null);
        setDiffRialCurrency(null);
        setCarat(null);
        setTaxSource(null);
        // setProductId('');
    };

    const selectStyle = {
        control: (provided) => ({
            ...provided,
            borderRadius: '7px',
            direction: 'rtl',
            border: '2px solid black',
            ':hover': {
                border: '2px solid black',
            },
        }),
        option: (provided, state) => ({
            ...provided,
            color: 'black',
            backgroundColor: state.isSelected ? 'lightgrey' : 'white',
            ':hover': {
                backgroundColor: state.isSelected ? 'lightgrey' : 'lightblue'
            }
        }),
    }

    useEffect(() => {
    }, [measurement]);

    useEffect(() => {
        const fee = parseFloat(constructionFee) || 0;
        const profit = parseFloat(sellerProfit) || 0;
        const comm = parseFloat(commission) || 0;
        setSumCSC((fee + profit + comm).toString());
    }, [constructionFee, sellerProfit, commission]);
    useEffect(() => {
        if (activeAlgo === 'Seventh') {
            const rialPri = parseFloat(rialValue) || 0;
            const taxPri = parseFloat(taxPrice) || 0;
            const otherTP = parseFloat(otherTaxP) || 0;
            const otherLP = parseFloat(otherLegalP) || 0;
            setTotalPrice((rialPri + taxPri + otherTP + otherLP).toString());
        } else {
            const taxPri = parseFloat(taxPrice) || 0;
            const priceAS = parseFloat(priceAfterSale) || 0;
            const otherTP = parseFloat(otherTaxP) || 0;
            const otherLP = parseFloat(otherLegalP) || 0;
            setTotalPrice((priceAS + taxPri + otherTP + otherLP).toString());
        }
    }, [rialValue, taxPrice, otherTaxP, otherLegalP, priceAfterSale]);
    useEffect(() => {
        console.log(activeAlgo)
        if (activeAlgo == 'Third') {
            console.log('in true algo')
            const priceBS = parseFloat(priceBeforeSale) || 0;
            const saleP = parseFloat(salePrice) || 0;
            const sumCSCFAfterSale = parseFloat(sumCSC) || 0;
            setPriceAfterSale(((priceBS + sumCSCFAfterSale) - saleP).toString());
        } else {
            const priceBS = parseFloat(priceBeforeSale) || 0;
            const saleP = parseFloat(salePrice) || 0;
            setPriceAfterSale((priceBS - saleP).toString());
        }
    }, [priceBeforeSale, salePrice, sumCSC]);
    useEffect(() => {
        const taxP = parseFloat(taxPrice) || 0;
        setVppSuggestions([taxP.toString()]);
    }, [taxPrice]);
    useEffect(() => {
        const taxP = parseFloat(taxPrice) || 0;
        const cashC = parseFloat(cashContribution) || 0;
        const priceAS = parseFloat(priceAfterSale) || 0;
        setVpp(Math.trunc((taxP * cashC) / priceAS).toString());
    }, [taxPrice, cashContribution, priceAfterSale]);

    useEffect(() => {
        if (activeAlgo == 'Second') {
            const cA = parseFloat(currencyAmount) || 0;
            const cP = parseFloat(currencyPrice) || 0;
            setPriceBeforeSale(Math.trunc(cA * cP).toString())
        } else if (activeAlgo == 'Sixth') {
            const unitP = parseFloat(unitPrice) || 0;
            setPriceBeforeSale(unitP)
        } else {
            const amP = parseFloat(amount) || 0;
            const unitP = parseFloat(unitPrice) || 0;
            setPriceBeforeSale(Math.trunc(amP * unitP).toString())
        }

    }, [amount, unitPrice, currencyAmount, currencyPrice]);
    useEffect(() => {
        if (activeAlgo == 'Second') {
            const taxS = parseFloat(taxSource) || 0;
            const taxP = parseFloat(taxPercent) || 0;
            setTaxPrice(Math.trunc((taxS * taxP) / 100).toString())
        } else if (activeAlgo == 'Third') {
            const sumCSCFAfterSale = parseFloat(sumCSC) || 0;
            const priceBS = parseFloat(priceBeforeSale) || 0;
            const taxP = parseFloat(taxPercent) || 0;
            setTaxPrice(Math.trunc(((sumCSCFAfterSale * 10) / 100) + ((priceBS * taxP) / 100)).toString())
        } else {
            const saleP = parseFloat(priceBeforeSale) || 0;
            const taxP = parseFloat(taxPercent) || 0;
            setTaxPrice(Math.trunc((saleP * taxP) / 100).toString())
        }
    }, [taxPercent, priceBeforeSale, taxSource, sumCSC]);
    useEffect(() => {
        const parsed = parseFloat(totalPrice);
        if (!isNaN(parsed) && (cashContribution === null || cashContribution === '' || cashContribution === 0)) {
            setCashContribution(Math.trunc(parsed).toString());
        }
    }, [totalPrice]);
    const getUserProfItems = async () => {
        setLoading(true)
        try {
            const result = await apiClient('user-preferences/api/user-product/');
            if (Array.isArray(result.data) && result.data.length > 0) {
                const productsData = result.data.map(i => ({
                    id: i.id,
                    name: i.goods_and_services.name,
                    code: i.goods_and_services.code,
                    identity: i.goods_and_services.identity,
                    identityName: i.goods_and_services.identityName,
                    barcode: i.goods_and_services.barcode,
                    taxPercent: i.goods_and_services.taxPercent,
                }))
                setUserProfProducts(productsData)
            }
        } catch (e) {
            console.log(e)
        }
        setLoading(false)
    }

    useEffect(() => {
        getUserProfItems()
    }, []);
    useEffect(() => {
        if (activeAlgo == 'Sixth' || activeAlgo == 'Eighth') {
            setAmount(1)
        }
    }, [amount]);
return (
    <Modal.Body className="d-flex rtl flex-column">
        {loading ? (
            <div className="text-center p-5 bg-secondary-subtle rounded border">
                <p className="fs-2">در حال بارگذاری داده‌ها...</p>
            </div>
        ) : (
            <div className="invoice-products">
                <div className="d-flex mb-4 align-items-center">
                    <div className="bg-secondary flex-grow-1" style={{ height: '1px', opacity: 0.3 }}></div>
                    <h6 className="mb-0 mx-2">اطلاعات اولیه کالا</h6>
                    <div className="bg-secondary flex-grow-1 me-3" style={{ height: '1px', opacity: 0.3 }}></div>
                </div>
                
                <div className="row g-3 mb-5">
                    <div className="col-12 col-md-4 col-lg-3 position-relative">
                        <label htmlFor="productId" className="form-label">
                            شناسه کالا/خدمت {isRequired('productId') && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="number"
                            id="productId"
                            className={`form-control ${inputErrors.productId ? 'is-invalid' : ''}`}
                            value={productId}
                            onChange={handleFieldChange({ setter: setProductId, fieldName: 'productId' })}
                            disabled={mode !== 1}
                            onFocus={() => {
                                if (userProfProducts.length > 0) setShowUserProfProducts(true);
                            }}
                            onBlur={() => setTimeout(() => setShowUserProfProducts(false), 200)}
                        />
                        {inputErrors.productId && <div className="invalid-feedback d-block">{inputErrors.productId}</div>}
                        
                        {showUserProfProducts && (
                            <ul className="dropdown-menu show w-100 position-absolute overflow-auto p-0 m-0 shadow-sm" style={{ zIndex: 1000, maxHeight: '150px' }}>
                                {userProfProducts
                                    .filter(item => !productId || item.identity.toString().includes(productId.toString()))
                                    .map((item, idx) => (
                                        <li
                                            key={idx}
                                            onMouseDown={() => handleSelectUserProfProducts(item)}
                                            className="dropdown-item py-2 border-bottom"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {item.name} - {item.identity}
                                        </li>
                                    ))}
                            </ul>
                        )}
                    </div>

                    <div className="col-12 col-md-4 col-lg-3">
                        <label htmlFor="name" className="form-label">
                            عنوان کالا/خدمت {isRequired('name') && <span className="text-danger">*</span>}
                        </label>
                        <input
                            type="text"
                            id="name"
                            className={`form-control ${inputErrors.name ? 'is-invalid' : ''}`}
                            value={name}
                            onChange={handleFieldChange({ setter: setName, fieldName: 'name', type: 'text' })}
                            disabled={mode !== 1}
                        />
                        {inputErrors.name && <div className="invalid-feedback d-block">{inputErrors.name}</div>}
                    </div>

                    {isShow('measurement') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="measurement" className="form-label">
                                واحد اندازه گیری {isRequired('measurement') && <span className="text-danger">*</span>}
                            </label>
                            <Select
                                inputId="measurement"
                                options={measurementOption}
                                styles={selectStyle}
                                onChange={(selectedOption) => handleChangeSelect(selectedOption, 'measurement')}
                                value={measurementOption.find(option => option.value === measurement) || null}
                                isDisabled={mode === 4}
                                className={inputErrors.measurement ? 'is-invalid' : ''}
                            />
                            {inputErrors.measurement && <div className="invalid-feedback d-block">{inputErrors.measurement}</div>}
                        </div>
                    )}

                    {isShow('amount') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="amount" className="form-label">
                                تعداد/مقدار {isRequired('amount') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="amount"
                                className={`form-control ${inputErrors.amount ? 'is-invalid' : ''}`}
                                value={amount}
                                onChange={handleFieldChange({ setter: setAmount, fieldName: 'amount', onlyPositive: true, maxDigits: 18, maxDecimals: 8 })}
                                disabled={activeAlgo === 'Sixth' || activeAlgo === 'Eighth'}
                            />
                            {inputErrors.amount && <div className="invalid-feedback d-block">{inputErrors.amount}</div>}
                        </div>
                    )}

                    {isShow('weight') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="weight" className="form-label">
                                وزن خالص {isRequired('weight') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="weight"
                                className={`form-control ${inputErrors.weight ? 'is-invalid' : ''}`}
                                value={weight}
                                onChange={handleFieldChange({ setter: setWeight, fieldName: 'weight' })}
                                disabled={mode === 4}
                            />
                            {inputErrors.weight && <div className="invalid-feedback d-block">{inputErrors.weight}</div>}
                        </div>
                    )}
                </div>

                <div className="d-flex mb-4 align-items-center">
                    <div className="bg-secondary flex-grow-1" style={{ height: '1px', opacity: 0.3 }}></div>
                    <h6 className="mb-0 mx-2">ارزش، تخفیفات کالا</h6>
                    <div className="bg-secondary flex-grow-1 me-3" style={{ height: '1px', opacity: 0.3 }}></div>
                </div>

                <div className="row g-3 mb-5">
                    {isShow('currency') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="currency" className="form-label">
                                نوع ارز {isRequired('currency') && <span className="text-danger">*</span>}
                            </label>
                            <Select
                                inputId="currency"
                                options={currencyOption}
                                styles={selectStyle}
                                onChange={(selectedOption) => handleChangeSelect(selectedOption, 'currency')}
                                value={currencyOption.find(option => option.value === currency) || null}
                                isDisabled={mode === 4}
                                className={inputErrors.currency ? 'is-invalid' : ''}
                            />
                            {inputErrors.currency && <div className="invalid-feedback d-block">{inputErrors.currency}</div>}
                        </div>
                    )}

                    {isShow('unitPrice') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="unitPrice" className="form-label">
                                مبلغ واحد {isRequired('unitPrice') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="unitPrice"
                                className={`form-control ${inputErrors.unitPrice ? 'is-invalid' : ''}`}
                                value={unitPrice}
                                onChange={handleFieldChange({ setter: setUnitPrice, fieldName: 'unitPrice', onlyPositive: true, maxDigits: 18, maxDecimals: 8 })}
                                disabled={mode === 4}
                            />
                            {inputErrors.unitPrice && <div className="invalid-feedback d-block">{inputErrors.unitPrice}</div>}
                        </div>
                    )}

                    {isShow('currencyAmount') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="currencyAmount" className="form-label">
                                میزان ارز {isRequired('currencyAmount') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="currencyAmount"
                                className={`form-control ${inputErrors.currencyAmount ? 'is-invalid' : ''}`}
                                value={currencyAmount}
                                onChange={handleFieldChange({ setter: setCurrencyAmount, fieldName: 'currencyAmount', onlyPositive: true })}
                                disabled={mode == 4}
                            />
                            {inputErrors.currencyAmount && <div className="invalid-feedback d-block">{inputErrors.currencyAmount}</div>}
                        </div>
                    )}

                    {isShow('currencyPrice') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="currencyPrice" className="form-label">
                                نرخ برابری ارز با ریال/نرخ فروش ارز {isRequired('currencyPrice') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="currencyPrice"
                                className={`form-control ${inputErrors.currencyPrice ? 'is-invalid' : ''}`}
                                value={currencyPrice}
                                onChange={handleFieldChange({ setter: setCurrencyPrice, fieldName: 'currencyPrice', onlyPositive: true })}
                                disabled={mode === 4}
                            />
                            {inputErrors.currencyPrice && <div className="invalid-feedback d-block">{inputErrors.currencyPrice}</div>}
                        </div>
                    )}

                    {isShow('rialValue') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="rialValue" className="form-label">
                                ارزش ریالی کالا {isRequired('rialValue') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="rialValue"
                                className={`form-control ${inputErrors.rialValue ? 'is-invalid' : ''}`}
                                value={rialValue}
                                onChange={handleFieldChange({ setter: setRialValue, fieldName: 'rialValue', onlyPositive: true })}
                                disabled={mode === 4}
                            />
                            {inputErrors.rialValue && <div className="invalid-feedback d-block">{inputErrors.rialValue}</div>}
                        </div>
                    )}

                    {isShow('currencyValue') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="currencyValue" className="form-label">
                                ارزش ارزی کالا {isRequired('currencyValue') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="currencyValue"
                                className={`form-control ${inputErrors.currencyValue ? 'is-invalid' : ''}`}
                                value={currencyValue}
                                onChange={handleFieldChange({ setter: setCurrencyValue, fieldName: 'currencyValue', onlyPositive: true })}
                                disabled={mode === 4}
                            />
                            {inputErrors.currencyValue && <div className="invalid-feedback d-block">{inputErrors.currencyValue}</div>}
                        </div>
                    )}

                    {isShow('taxSource') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="taxSource" className="form-label">
                                ماخذ مالیات بر ارزش افزوده در الگوی فروش ارز {isRequired('taxSource') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="taxSource"
                                className={`form-control ${inputErrors.taxSource ? 'is-invalid' : ''}`}
                                value={taxSource}
                                onChange={handleFieldChange({ setter: setTaxSource, fieldName: 'taxSource' })}
                                disabled={mode === 4}
                            />
                            {inputErrors.taxSource && <div className="invalid-feedback d-block">{inputErrors.taxSource}</div>}
                        </div>
                    )}

                    {isShow('diffRialCurrency') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="diffRialCurrency" className="form-label">
                                نرخ خرید ارز {isRequired('diffRialCurrency') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="diffRialCurrency"
                                className={`form-control ${inputErrors.diffRialCurrency ? 'is-invalid' : ''}`}
                                value={diffRialCurrency}
                                onChange={handleFieldChange({ setter: setDiffRialCurrency, fieldName: 'diffRialCurrency' })}
                                disabled={mode === 4}
                            />
                            {inputErrors.diffRialCurrency && <div className="invalid-feedback d-block">{inputErrors.diffRialCurrency}</div>}
                        </div>
                    )}

                    {isShow('priceBeforeSale') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="priceBeforeSale" className="form-label">
                                مبلغ قبل از تخفیف {isRequired('priceBeforeSale') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="priceBeforeSale"
                                className={`form-control ${inputErrors.priceBeforeSale ? 'is-invalid' : ''}`}
                                value={priceBeforeSale}
                                readOnly
                                disabled={true}
                            />
                            {inputErrors.priceBeforeSale && <div className="invalid-feedback d-block">{inputErrors.priceBeforeSale}</div>}
                        </div>
                    )}

                    {isShow('salePrice') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="salePrice" className="form-label">
                                مبلغ تخفیف {isRequired('salePrice') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="salePrice"
                                className={`form-control ${inputErrors.salePrice ? 'is-invalid' : ''}`}
                                value={salePrice}
                                onChange={handleFieldChange({ setter: setSalePrice, fieldName: 'salePrice', onlyPositive: true })}
                                disabled={mode === 4}
                            />
                            {inputErrors.salePrice && <div className="invalid-feedback d-block">{inputErrors.salePrice}</div>}
                        </div>
                    )}

                    {isShow('priceAfterSale') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="priceAfterSale" className="form-label">
                                مبلغ بعد از تخفیف {isRequired('priceAfterSale') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="priceAfterSale"
                                className={`form-control ${inputErrors.priceAfterSale ? 'is-invalid' : ''}`}
                                value={priceAfterSale}
                                readOnly
                                disabled={true}
                            />
                            {inputErrors.priceAfterSale && <div className="invalid-feedback d-block">{inputErrors.priceAfterSale}</div>}
                        </div>
                    )}
                </div>

                <div className="d-flex mb-4 align-items-center">
                    <div className="bg-secondary flex-grow-1" style={{ height: '1px', opacity: 0.3 }}></div>
                    <h6 className="mb-0 mx-2">مالیات، عوارض و وجوه قانونی کالا</h6>
                    <div className="bg-secondary flex-grow-1 me-3" style={{ height: '1px', opacity: 0.3 }}></div>
                </div>

                <div className="row g-3 mb-5">
                    {isShow('taxPercent') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="taxPercent" className="form-label">
                                نرخ مالیات بر ارزش افزوده {isRequired('taxPercent') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="taxPercent"
                                className={`form-control ${inputErrors.taxPercent ? 'is-invalid' : ''}`}
                                value={taxPercent}
                                onChange={handleFieldChange({ setter: setTaxPercent, fieldName: 'taxPercent', onlyPositive: true })}
                                disabled={mode !== 1}
                            />
                            {inputErrors.taxPercent && <div className="invalid-feedback d-block">{inputErrors.taxPercent}</div>}
                        </div>
                    )}

                    {isShow('taxPrice') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="taxPrice" className="form-label">
                                مبلغ مالیات بر ارزش افزوده {isRequired('taxPrice') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="taxPrice"
                                className={`form-control ${inputErrors.taxPrice ? 'is-invalid' : ''}`}
                                value={taxPrice}
                                readOnly
                                disabled={true}
                            />
                            {inputErrors.taxPrice && <div className="invalid-feedback d-block">{inputErrors.taxPrice}</div>}
                        </div>
                    )}

                    {isShow('otherTaxS') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="otherTaxS" className="form-label">
                                موضوع سایر مالیات و عوارض {isRequired('otherTaxS') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="text"
                                id="otherTaxS"
                                className={`form-control ${inputErrors.otherTaxS ? 'is-invalid' : ''}`}
                                value={otherTaxS}
                                onChange={handleFieldChange({ setter: setOtherTaxS, fieldName: 'otherTaxS', type: 'text' })}
                                disabled={mode === 4}
                            />
                            {inputErrors.otherTaxS && <div className="invalid-feedback d-block">{inputErrors.otherTaxS}</div>}
                        </div>
                    )}

                    {isShow('otherTaxR') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="otherTaxR" className="form-label">
                                نرخ سایر مالیات و عوارض {isRequired('otherTaxR') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="otherTaxR"
                                className={`form-control ${inputErrors.otherTaxR ? 'is-invalid' : ''}`}
                                value={otherTaxR}
                                onChange={handleFieldChange({ setter: setOtherTaxR, fieldName: 'otherTaxR', onlyPositive: true })}
                                disabled={mode === 4}
                            />
                            {inputErrors.otherTaxR && <div className="invalid-feedback d-block">{inputErrors.otherTaxR}</div>}
                        </div>
                    )}

                    {isShow('otherTaxP') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="otherTaxP" className="form-label">
                                مبلغ سایر مالیات و عوارض {isRequired('otherTaxP') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="otherTaxP"
                                className={`form-control ${inputErrors.otherTaxP ? 'is-invalid' : ''}`}
                                value={otherTaxP}
                                onChange={handleFieldChange({ setter: setOtherTaxP, fieldName: 'otherTaxP', onlyPositive: true })}
                                disabled={mode === 4}
                            />
                            {inputErrors.otherTaxP && <div className="invalid-feedback d-block">{inputErrors.otherTaxP}</div>}
                        </div>
                    )}

                    {isShow('otherLegalS') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="otherLegalS" className="form-label">
                                موضوع سایر وجوه قانونی {isRequired('otherLegalS') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="text"
                                id="otherLegalS"
                                className={`form-control ${inputErrors.otherLegalS ? 'is-invalid' : ''}`}
                                value={otherLegalS}
                                onChange={handleFieldChange({ setter: setOtherLegalS, fieldName: 'otherLegalS', type: 'text' })}
                                disabled={mode === 4}
                            />
                            {inputErrors.otherLegalS && <div className="invalid-feedback d-block">{inputErrors.otherLegalS}</div>}
                        </div>
                    )}

                    {isShow('otherLegalR') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="otherLegalR" className="form-label">
                                نرخ سایر وجوه قانونی {isRequired('otherLegalR') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="otherLegalR"
                                className={`form-control ${inputErrors.otherLegalR ? 'is-invalid' : ''}`}
                                value={otherLegalR}
                                onChange={handleFieldChange({ setter: setOtherLegalR, fieldName: 'otherLegalR', onlyPositive: true })}
                                disabled={mode === 4}
                            />
                            {inputErrors.otherLegalR && <div className="invalid-feedback d-block">{inputErrors.otherLegalR}</div>}
                        </div>
                    )}

                    {isShow('otherLegalP') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="otherLegalP" className="form-label">
                                مبلغ سایر وجوه قانونی {isRequired('otherLegalP') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="otherLegalP"
                                className={`form-control ${inputErrors.otherLegalP ? 'is-invalid' : ''}`}
                                value={otherLegalP}
                                onChange={handleFieldChange({ setter: setOtherLegalP, fieldName: 'otherLegalP', onlyPositive: true })}
                                disabled={mode === 4}
                            />
                            {inputErrors.otherLegalP && <div className="invalid-feedback d-block">{inputErrors.otherLegalP}</div>}
                        </div>
                    )}
                </div>

                {isShow('constructionFee') && (
                    <>
                        <div className="d-flex mb-4 align-items-center">
                            <div className="bg-secondary flex-grow-1" style={{ height: '1px', opacity: 0.3 }}></div>
                            <h6 className="mb-0 mx-2">اجرت ها، حق العمل و سود کالا</h6>
                            <div className="bg-secondary flex-grow-1 me-3" style={{ height: '1px', opacity: 0.3 }}></div>
                        </div>

                        <div className="row g-3 mb-5">
                            <div className="col-12 col-md-4 col-lg-3">
                                <label htmlFor="constructionFee" className="form-label">
                                    اجرت ساخت {isRequired('constructionFee') && <span className="text-danger">*</span>}
                                </label>
                                <input
                                    type="number"
                                    id="constructionFee"
                                    className={`form-control ${inputErrors.constructionFee ? 'is-invalid' : ''}`}
                                    value={constructionFee}
                                    onChange={handleFieldChange({ setter: setConstructionFee, fieldName: 'constructionFee', onlyPositive: true })}
                                    disabled={mode === 4}
                                />
                                {inputErrors.constructionFee && <div className="invalid-feedback d-block">{inputErrors.constructionFee}</div>}
                            </div>

                            {isShow('carat') && (
                                <div className="col-12 col-md-4 col-lg-3">
                                    <label htmlFor="carat" className="form-label">
                                        عیار {isRequired('carat') && <span className="text-danger">*</span>}
                                    </label>
                                    <input
                                        type="number"
                                        id="carat"
                                        className={`form-control ${inputErrors.carat ? 'is-invalid' : ''}`}
                                        value={carat}
                                        onChange={handleFieldChange({ setter: setCarat, fieldName: 'carat', onlyPositive: true })}
                                        disabled={mode === 4}
                                    />
                                    {inputErrors.carat && <div className="invalid-feedback d-block">{inputErrors.carat}</div>}
                                </div>
                            )}

                            {isShow('sellerProfit') && (
                                <div className="col-12 col-md-4 col-lg-3">
                                    <label htmlFor="sellerProfit" className="form-label">
                                        سود فروشنده {isRequired('sellerProfit') && <span className="text-danger">*</span>}
                                    </label>
                                    <input
                                        type="number"
                                        id="sellerProfit"
                                        className={`form-control ${inputErrors.sellerProfit ? 'is-invalid' : ''}`}
                                        value={sellerProfit}
                                        onChange={handleFieldChange({ setter: setSellerProfit, fieldName: 'sellerProfit', onlyPositive: true })}
                                        disabled={mode === 4}
                                    />
                                    {inputErrors.sellerProfit && <div className="invalid-feedback d-block">{inputErrors.sellerProfit}</div>}
                                </div>
                            )}

                            {isShow('commission') && (
                                <div className="col-12 col-md-4 col-lg-3">
                                    <label htmlFor="commission" className="form-label">
                                        حق العمل {isRequired('commission') && <span className="text-danger">*</span>}
                                    </label>
                                    <input
                                        type="number"
                                        id="commission"
                                        className={`form-control ${inputErrors.commission ? 'is-invalid' : ''}`}
                                        value={commission}
                                        onChange={handleFieldChange({ setter: setCommission, fieldName: 'commission', onlyPositive: true })}
                                        disabled={mode === 4}
                                    />
                                    {inputErrors.commission && <div className="invalid-feedback d-block">{inputErrors.commission}</div>}
                                </div>
                            )}

                            {isShow('constructionFeeNum') && (
                                <div className="col-12 col-md-4 col-lg-3">
                                    <label htmlFor="constructionFeeNum" className="form-label">
                                        شماره قرارداد حق العمل کاری {isRequired('constructionFeeNum') && <span className="text-danger">*</span>}
                                    </label>
                                    <input
                                        type="number"
                                        id="constructionFeeNum"
                                        className={`form-control ${inputErrors.constructionFeeNum ? 'is-invalid' : ''}`}
                                        value={constructionFeeNum}
                                        onChange={handleFieldChange({ setter: setConstructionFeeNum, fieldName: 'constructionFeeNum', onlyPositive: true })}
                                        disabled={mode === 4}
                                    />
                                    {inputErrors.constructionFeeNum && <div className="invalid-feedback d-block">{inputErrors.constructionFeeNum}</div>}
                                </div>
                            )}

                            {isShow('sumCSC') && (
                                <div className="col-12 col-md-4 col-lg-3">
                                    <label htmlFor="sumCSC" className="form-label">
                                        جمع کل اجرت، حق العمل و سود {isRequired('sumCSC') && <span className="text-danger">*</span>}
                                    </label>
                                    <input
                                        type="number"
                                        id="sumCSC"
                                        className={`form-control ${inputErrors.sumCSC ? 'is-invalid' : ''}`}
                                        value={sumCSC}
                                        readOnly
                                        disabled={true}
                                    />
                                    {inputErrors.sumCSC && <div className="invalid-feedback d-block">{inputErrors.sumCSC}</div>}
                                </div>
                            )}
                        </div>
                    </>
                )}

                <div className="d-flex mb-4 align-items-center">
                    <div className="bg-secondary flex-grow-1" style={{ height: '1px', opacity: 0.3 }}></div>
                    <h6 className="mb-0 mx-2">اطلاعات نهایی کالا</h6>
                    <div className="bg-secondary flex-grow-1 me-3" style={{ height: '1px', opacity: 0.3 }}></div>
                </div>

                <div className="row g-3 mb-4">
                    {isShow('totalPrice') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="totalPrice" className="form-label">
                                مبلغ کل کالا/خدمت {isRequired('totalPrice') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="totalPrice"
                                className={`form-control ${inputErrors.totalPrice ? 'is-invalid' : ''}`}
                                value={totalPrice}
                                readOnly
                                disabled={true}
                            />
                            {inputErrors.totalPrice && <div className="invalid-feedback d-block">{inputErrors.totalPrice}</div>}
                        </div>
                    )}

                    {isShow('cashContribution') && (
                        <div className="col-12 col-md-4 col-lg-3">
                            <label htmlFor="cashContribution" className="form-label">
                                سهم نقدی از پرداخت {isRequired('cashContribution') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="cashContribution"
                                className={`form-control ${inputErrors.cashContribution ? 'is-invalid' : ''}`}
                                value={cashContribution}
                                onChange={handleFieldChange({ setter: setCashContribution, fieldName: 'cashContribution', onlyPositive: true })}
                                disabled={mode === 4}
                            />
                            {inputErrors.cashContribution && <div className="invalid-feedback d-block">{inputErrors.cashContribution}</div>}
                        </div>
                    )}

                    {isShow('vpp') && (
                        <div className="col-12 col-md-4 col-lg-3 position-relative">
                            <label htmlFor="vpp" className="form-label">
                                سهم مالیات بر ارزش افزوده از پرداخت {isRequired('vpp') && <span className="text-danger">*</span>}
                            </label>
                            <input
                                type="number"
                                id="vpp"
                                className={`form-control ${inputErrors.vpp ? 'is-invalid' : ''}`}
                                value={vpp}
                                onChange={(e) => setVpp(e.target.value)}
                                disabled={mode === 4}
                                onFocus={() => setShowVppSuggestions(true)}
                                onBlur={() => setTimeout(() => setShowVppSuggestions(false), 200)}
                            />
                            {inputErrors.vpp && <div className="invalid-feedback d-block">{inputErrors.vpp}</div>}
                            
                            {showVppSuggestions && (
                                <ul className="dropdown-menu show w-100 position-absolute overflow-auto p-0 m-0 shadow-sm" style={{ zIndex: 1000, maxHeight: '150px' }}>
                                    {vppSuggestions.map((item, idx) => (
                                        <li
                                            key={idx}
                                            onMouseDown={() => handleSelectVppSuggestion(item)}
                                            className="dropdown-item py-2 border-bottom"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    )}
                </div>

                <Modal.Footer className="mt-4 pt-4 border-top d-flex gap-2 justify-content-end">
                    <button type="button" className="btn btn-secondary px-4" onClick={onClose}>
                        لغو
                    </button>
                    <button type="button" className="btn btn-success px-4" onClick={handleSubmitAndAdd}>
                        ذخیره و اضافه کردن کالا/خدمت جدید
                    </button>
                    <button type="button" className="btn btn-primary px-4" onClick={handleSubmit}>
                        ذخیره
                    </button>
                </Modal.Footer>
            </div>
        )}
    </Modal.Body>
);

}

export default AddProductModal;